export default{
    // 疫情退改申请
    async generateAccessURI(params) {
        let actiontype = 'generateAccessURI';
        return await this.fetch(actiontype, params);
    },
    
}


// WEBPACK FOOTER //
// ./src/interfaces/modules/wxmp.js